import {
  EmailValidator,
  Form,
  FormField,
  IFormField,
  MustMatchValidator,
  PatternValidator,
  RequiredValidator,
} from '@thinknimble/tn-forms'

export const MIN_PIN_LENGTH = 6

export type SurveyPinFormInputs = {
  email: IFormField<string>
  pin: IFormField<string>
  confirmPin: IFormField<string>
}

/**
 * PIN a respondent sets on a secure survey: numeric, at least six digits, entered
 * twice, plus the email the PIN and resume link are sent to.
 */
export class SurveyPinForm extends Form<SurveyPinFormInputs> {
  static email = FormField.create({
    label: 'Email',
    type: 'email',
    value: '',
    validators: [
      new RequiredValidator({ message: 'emailRequired' }),
      new EmailValidator({ message: 'emailFormat' }),
    ],
  })

  static pin = FormField.create({
    label: 'PIN',
    type: 'password',
    value: '',
    validators: [
      new RequiredValidator({ message: 'pinRequired' }),
      new PatternValidator({
        pattern: new RegExp(`^\\d{${MIN_PIN_LENGTH},}$`),
        message: 'pinFormat',
      }),
    ],
  })

  static confirmPin = FormField.create({
    label: 'Confirm PIN',
    type: 'password',
    value: '',
    validators: [],
  })
}
export type TSurveyPinForm = SurveyPinForm & SurveyPinFormInputs

export const surveyPinFormLevelValidators = {
  confirmPin: new MustMatchValidator({ message: 'pinMismatch', matcher: 'pin' }),
}

export type SurveyPinEntryFormInputs = {
  pin: IFormField<string>
}

/** The PIN a respondent enters to reopen their secure survey. */
export class SurveyPinEntryForm extends Form<SurveyPinEntryFormInputs> {
  static pin = FormField.create({
    label: 'PIN',
    type: 'password',
    value: '',
    validators: [new RequiredValidator({ message: 'pinRequired' })],
  })
}
export type TSurveyPinEntryForm = SurveyPinEntryForm & SurveyPinEntryFormInputs
